module.exports = __webpack_public_path__ + "static/media/Rectangle 85 (1).33a69c61.jpg";